import { EducationalContent } from './EducationalContent';

enum EventContent {
  LegalIssues = 25,
  Buyback = 232,
  Delisting = 12,
  FollowOnEquity = 86,
  DividendIncrease = 46,
  DividendDecrease = 47,
  DividendInitiation = 214,
}

interface Props {
  subType: EventContent;
}

export const EventsEducationalContent = ({ subType }: Props) => {
  switch (subType) {
    case EventContent.LegalIssues:
      return (
        <EducationalContent
          title="Legal Issues"
          content="Understand how various legal developments might affect your investments."
          link="https://youtu.be/JV8vA4XunX4"
        />
      );
    case EventContent.Buyback:
      return (
        <EducationalContent
          title="Buyback Announcements"
          content="Understand what the buyback means for your investment."
          link="https://youtu.be/JV8vA4XunX4?t=141"
        />
      );
    case EventContent.Delisting:
      return (
        <EducationalContent
          title="Company Delistings"
          content="Understand why a company’s stock is delisting, and what the impact may be for your shares."
          link="https://youtu.be/JV8vA4XunX4?t=385"
        />
      );
    case EventContent.FollowOnEquity:
      return (
        <EducationalContent
          title="Follow-on Equity Offerings"
          content="Understand what a follow-on equity offering is, and how it might affect your investment."
          link="https://youtu.be/JV8vA4XunX4?t=385"
        />
      );
    case EventContent.DividendIncrease:
      return (
        <EducationalContent
          title="Dividend Increases"
          content="Find out how increased dividends affect the outlook for your investment."
          link="https://www.youtube.com/watch?v=YoPkVqRTXaI&list=PLVdrK24l-IHfHaih5wmYOgnrMEPqCNtkT&index=7"
        />
      );
    case EventContent.DividendDecrease:
      return (
        <EducationalContent
          title="Dividend Decreases"
          content="Find out how decreased dividends affect the outlook for your investment."
          link="https://www.youtube.com/watch?v=YoPkVqRTXaI&list=PLVdrK24l-IHfHaih5wmYOgnrMEPqCNtkT&index=7"
        />
      );
    case EventContent.DividendInitiation:
      return (
        <EducationalContent
          title="Dividend Initiations"
          content="Find out how dividends affect the outlook for your investment."
          link="https://www.youtube.com/watch?v=YoPkVqRTXaI&list=PLVdrK24l-IHfHaih5wmYOgnrMEPqCNtkT&index=7"
        />
      );
  }
};
